import Carousel from './Carousel';
import Infos from './Infos';
import IconText from './ui/IconText';

const Banner = ({ userType }) => {
    const isEmprunteur = userType === 'emprunteur';

    return (
        <section className='max-w-7xl mx-auto h-full mb-12 md:mb-14'>
            <div className='mb-8 flex flex-col lg:flex-row lg:gap-2'>
                <div className='mb-8 flex flex-col items-start flex-1 px-4 lg:px-0'>
                    {isEmprunteur ?
                        <h1 className={`text-4xl lg:text-5xl font-semibold leading-none mb-4 text-center md:text-left ${isEmprunteur ? 'text-primary' : 'text-secondary'}`}>
                            Accédez à une solution de Financement simple
                        </h1>
                        :
                        <h1 className={`text-4xl lg:text-5xl font-semibold leading-none mb-4 text-center md:text-left ${isEmprunteur ? 'text-primary' : 'text-secondary'}`}>
                            Investissez<br />directement dans les PME en croissance
                        </h1>
                    }
                    {isEmprunteur ?
                        <>
                            <p className='max-w-[480px] mb-4 text-justify'>Financez vos projets de développement (BFR, croissance, recrutement, logiciels, stocks, machines d'occasion..)</p>
                            <div>
                                <IconText text={"PME crées depuis plus de 3 ans"} className='mb-2' iconSize={22} iconClass={'mr-2 text-primary'} />
                                <IconText text={"Financièrement saine, capitaux propres positifs"} className='mb-2' iconSize={22} iconClass={'mr-2 text-primary'} />
                                <IconText text={"Plus de 150K€ de chiffre d'affaires"} className='text-black' iconSize={22} iconClass={'mr-2 text-primary'} />
                            </div>
                        </>
                        :
                        <>
                            <p className='max-w-[480px] mb-4 text-justify'>
                                La performance de l’investissement en prêt au service des PME françaises depuis 2015.
                            </p>
                            <div>
                                <IconText text={"Rendement cible : jusqu'à 11%* par an"} className='mb-2' iconSize={22} iconClass={'mr-2 text-secondary'} />
                                <IconText text={"Durée d'investissement moyenne : 24 mois"} className='mb-2' iconSize={22} iconClass={'mr-2 text-secondary'} />
                                <IconText text={"Investissement dès 20€ dans des opportunités analysées avec rigueur"} className='text-black' iconSize={22} iconClass={'mr-2 text-secondary'} />
                            </div>
                        </>
                    }


                </div>
                <div className="flex-1 max-w-[50%] lg:w-[690px] hidden lg:block">
                    <Carousel />
                </div>
            </div>
            <Infos userType={userType} />
        </section>
    );
}

export default Banner;